<template>
  <div style="text-align: center;">
    <v-btn v-if="checkCondition(item) === SendCondition.ErsalMadrak" class="btn" color="green white--text" rounded
      @click="$emit('showPostRequestForm', item)">
      درخواست ارسال مدرک
    </v-btn>
    <v-btn v-else-if="checkCondition(item) === SendCondition.Pardakht" class="btn" color="green white--text" rounded
      @click="$emit('showPostRequestForm', item)">
      پرداخت
    </v-btn>
    <v-btn v-else-if="checkCondition(item) === SendCondition.PardakhtShode" class="btn" color="green white--text"
      rounded :disabled="true">
      پرداخت شده
    </v-btn>
    <v-btn v-else-if="checkCondition(item) === SendCondition.Barchasb" class="btn" color="green white--text" rounded
      :disabled="true">
      برچسب زده شده
    </v-btn>
    <v-btn v-else-if="checkCondition(item) === SendCondition.SentToPost" class="btn" color="green white--text" rounded
      :disabled="true">
      به اداره پست ارسال شده
    </v-btn>

    <v-btn v-else-if="checkCondition(item) === SendCondition.Cancelled" class="btn" color="green white--text" rounded
      @click="$emit('showPostRequestForm', item)">
      لغو شده - درخواست مجدد
    </v-btn>


  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
import { PostRequestStep_Enum, PostRequestState_Enum } from "@/utils/constants";
export default {
  props: ["item"],
  data() {
    return {
      SendCondition: {
        ErsalMadrak: -1,
        Pardakht: 0,
        PardakhtShode: 1,
        Barchasb: 2,
        SentToPost: 3,
        NotShowed: 5,
        Cancelled: 4
      },
      postRequestStep: PostRequestStep_Enum.PostRequest,
      PostRequestState_Enum: PostRequestState_Enum,
    };
  },
  methods: {
    checkCondition(item) {
      if (item.State !== 1) {
        return this.SendCondition.NotShowed;
      } else {
        if (!item.postInfo) {
          return this.SendCondition.ErsalMadrak;
        } else if (item.postInfo?.State === PostRequestState_Enum.NotPaid) {
          return this.SendCondition.Pardakht;
        } else if (item.postInfo?.State === PostRequestState_Enum.Paid) {
          return this.SendCondition.PardakhtShode;
        } else if (item.postInfo?.State === PostRequestState_Enum.Tagged) {
          return this.SendCondition.Barchasb;
        } else if (
          item.postInfo?.State === PostRequestState_Enum.SentToPostOffice
        ) {
          return this.SendCondition.SentToPost;
        }
        else if (
          item.postInfo?.State === PostRequestState_Enum.Cancelled
        ) {
          return this.SendCondition.Cancelled;
        }
      }
    },
  },
  computed: {},
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}

.btn {
  margin: 10px 0;
}

@media screen and (max-width: 600px) {
  .btn {
    float: left;
    margin-right: 20px;
    margin-left: 20px;
  }
}
</style>
